import data from './attrs/data'
import methods from './attrs/methods'

export default {
    name: 'PasswordRecovery',
    data,
    methods
}
